import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { BillingModeEnum } from 'Data/interfaces/Faturamento/IRateio';
import {
  Hint,
  Label,
  Option,
  OptionDescription,
  OptionText,
  OptionTitle,
  Options,
  Radio,
  Wrapper,
} from './styles';

interface IBillingModeSelector {
  value: BillingModeEnum;
  disabled?: boolean;
  hint?: string;
  onChange: (mode: BillingModeEnum) => void;
}

const BillingModeSelector: FC<IBillingModeSelector> = ({
  value,
  disabled,
  hint,
  onChange,
}) => {
  const { t } = useTranslation('faturamento');

  const options = [
    {
      mode: BillingModeEnum.SingleCompany,
      title: t('rateio.modeSingleCompany'),
      description: t('rateio.modeSingleCompanyDescription'),
    },
    {
      mode: BillingModeEnum.SpeSplit,
      title: t('rateio.modeSpeSplit'),
      description: t('rateio.modeSpeSplitDescription'),
    },
  ];

  return (
    <Wrapper>
      <Label>{t('rateio.modeLabel')}</Label>
      <Options>
        {options.map((option) => {
          const selected = value === option.mode;
          return (
            <Option
              key={option.mode}
              type="button"
              role="radio"
              aria-checked={selected}
              aria-label={option.title}
              disabled={disabled}
              $selected={selected}
              onClick={() => onChange(option.mode)}
            >
              <Radio $selected={selected} />
              <OptionText>
                <OptionTitle>{option.title}</OptionTitle>
                <OptionDescription>{option.description}</OptionDescription>
              </OptionText>
            </Option>
          );
        })}
      </Options>
      {hint ? <Hint>{hint}</Hint> : null}
    </Wrapper>
  );
};

export default BillingModeSelector;
